module.exports = __webpack_public_path__ + "static/media/kakao_icon_white.65626762.png";